import { ErrorApi } from './api';

/**
 * Qué hacer cuando no se pudo confirmar la sesión al arrancar.
 *
 * ## Por qué esto es una función y no un `if` dentro del efecto
 *
 * Porque es la decisión que **distingue tres cosas que se parecen** y que antes
 * se trataban como una sola: la sesión murió, no hubo forma de preguntar, o
 * todavía vale la pena insistir. Con las tres mezcladas, una caída del servidor
 * se veía igual que «te cerramos la sesión»: el residente tecleaba su
 * contraseña, recibía un error de red que no explicaba nada, y concluía que la
 * app estaba rota.
 *
 * Aquí sola se puede probar; dentro de un `useEffect` haría falta montar el
 * árbol de React para comprobar un `if`.
 */

/** Cuántas veces se intenta antes de rendirse y decir que no hay conexión. */
export const INTENTOS_PERFIL = 3;

/** Lo que se espera entre intentos, multiplicado por el número de intento. */
export const ESPERA_PERFIL_MS = 800;

export type Reaccion =
  /** El servidor dice que quien pregunta ya no es nadie. A entrar de nuevo. */
  | 'sesion-muerta'
  /** Puede ser pasajero: se insiste. */
  | 'reintentar'
  /** Se agotaron los intentos. El token **se conserva**. */
  | 'sin-conexion';

export function reaccionAlFallo(e: unknown, intento: number): Reaccion {
  // **Solo el 401 mata la sesión.** Es el único que habla de quién eres; un 500
  // o un 502 hablan del servidor, y echar a alguien porque el proxy tosió es
  // exactamente el error que esto viene a corregir.
  if (e instanceof ErrorApi && e.estado === 401) return 'sesion-muerta';

  return intento >= INTENTOS_PERFIL ? 'sin-conexion' : 'reintentar';
}
